export default function() {
  
  const widgetName = 'swiperWidget';
  const widgetOpts = swiperWidgetOpts;

  // Template
  function buildSlideTemplate(slide) {

    const noDescriptionClass = slide.Description ? '' : 'no-description';
    const alignment = slide.Title.substring(1,2).toLowerCase();
    const title = `<h2>${slide.Title.substring(3)}</h2>`;
    const description = slide.Description ? `<p>${slide.Description}</p>` : '';

    const buttons = function(btn1, btn1Text, btn2, btn2Text) {
      if (btn1 || btn2) {
        let btnContainer = $('<div class="button-container"></div>');
        if (btn2) {
          btnContainer.append(`<a href="${btn2}" class="button">${btn2Text}</a>`);
        }        
        if (btn1) {
          btnContainer.append(`<a href="${btn1}" class="button">${btn1Text}</a>`);
        }
        return btnContainer.prop('outerHTML');
      } else {
        return '';
      }
    }

    let alignmentClass;
    if (alignment === 'l') {
      alignmentClass = 'sw-align-left';
    } else if (alignment === 'r') {
      alignmentClass = 'sw-align-right';
    } else {
      alignmentClass = 'sw-align-right';
    }

    const template = `
      <div class="swiper-slide">
        <div class="swiper-image-container" style="background-image: url('${slide.ImageWithPath}');" aria-label="${slide.ImageAlternateText}"></div>
        <div class="swiper-content-container ${alignmentClass}">
          <div class="swiper-content ${noDescriptionClass}">
            <div class="swiper-content-inner">
              ${title}
              ${description}
            </div>
            ${buttons(slide.URL, slide.DetailLinkText, slide.PurchaseURL, slide.PurchaseLinkText)}
          </div>
        </div>
      </div>
    `;

    return template;
  }



  // Fetch data
  saffire.utils.getWidgetData(widgetOpts).then(function(response) {
    if (response.Slides.length > 0) {
      initSwiper(response.Slides);
    } else {
      console.log(response);
      console.log('Error: No Data for swiperWidget');
    }
  });


  // Initialize Swiper
  function initSwiper(widgetData) {
    const swiperWidgetWrapper = $('.swiperWidget .swiper-wrapper');

    widgetData.forEach(function(slide, i) {
      swiperWidgetWrapper.append(buildSlideTemplate(slide));
    });

    const swiperWidgetInit = new Swiper('.swiperWidget .swiper-container', {
      speed: 600,
      autoplay: {
        delay: 8000,
      },
      slidesPerView: 'auto',
      spaceBetween: 0,
      centeredSlides: false,
      autoHeight: true,
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    });

  }

}





